import * as React from 'react';
import { useDispatch } from 'react-redux';
import fetchClient from 'utils/requestInterceptor';
import { API_ENDPOINTS } from 'utils/configs';
import { UrlFragments } from 'app/constants';
import { useUseUnauthorisedHandlerSlice } from './slice';
import { history } from 'utils/history';
const { stats, unauthorised } = UrlFragments;

export const useAuthorisationHandler = (
  isTokenSet: boolean,
  isAuthenticated: boolean,
) => {
  const dispatch = useDispatch();

  const {
    actions: { setUnauthorised },
  } = useUseUnauthorisedHandlerSlice();

  React.useEffect(() => {
    async function authorizationCheck() {
      fetchClient
        .get(API_ENDPOINTS.USER + stats)
        .then(() => {
          dispatch(setUnauthorised(false));
        })
        .catch(err => {
          if ([401, 403].includes(err?.response?.status)) {
            dispatch(setUnauthorised(true));
            history.push(`/${unauthorised}`);
          }
        });
    }
    if (isAuthenticated && isTokenSet) {
      authorizationCheck();
    }
  }, [isTokenSet, isAuthenticated, dispatch, setUnauthorised]);
};
